import { render, staticRenderFns } from "./POI.vue?vue&type=template&id=48888063&scoped=true&"
import script from "./POI.vue?vue&type=script&lang=js&"
export * from "./POI.vue?vue&type=script&lang=js&"
import style0 from "./POI.vue?vue&type=style&index=0&id=48888063&prod&scoped=true&lang=css&"
import style1 from "./POI.vue?vue&type=style&index=1&id=48888063&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48888063",
  null
  
)

export default component.exports